import { useCallback, useState } from 'react';

import UserSearch from '@sayyesschool/frontend/components/user-search';
import { Checkbox, Text } from '@sayyesschool/frontend/ui-components';
import Form from '@sayyesschool/frontend/ui-components/form';

export default function MeetingRegistrationForm({ user, onSubmit, ...props }) {
    const [userId, setUserId] = useState(user?.id);
    const [force, setForce] = useState(false);
    const [notify, setNotify] = useState(false);

    const handleSubmit = useCallback(() => {
        onSubmit({ userId, force, notify });
    }, [userId, force, notify, onSubmit]);

    const handleResult = useCallback(userId => {
        setUserId(userId);
    }, []);

    return (
        <Form onSubmit={handleSubmit} {...props}>
            {user ?
                <Text type="body-lg" color="primary">{user.fullname}</Text> :
                <UserSearch onResult={handleResult} />}

            <Checkbox
                label="Требуется абонемент"
                checked={!force}
                onChange={() => setForce(v => !v)}
            />

            <Checkbox
                label="Отправить письмо с регистрацией на встречу"
                checked={notify}
                onChange={() => setNotify(v => !v)}
            />
        </Form>
    );
}